module.exports = __webpack_public_path__ + "img/taili.1b146982.jpg";